module.exports = __webpack_public_path__ + "static/img/learn_more_icon.9a4a44e4.png";